module.exports = __webpack_public_path__ + "static/media/logo_lbg.c4c5c612.svg";